export default __webpack_public_path__ + "static/media/pezuñas.a34f571b.jpg";